import { useCallback } from 'react';

type SupportedFormat = 'defaultDateFormat' | 'defaultDateTimeFormat' | 'defaultTimeFormat';

export const useGetDatePickerFormat = () =>
  useCallback((format: SupportedFormat) => {
    switch (format) {
      case 'defaultDateFormat':
        return 'PP';
      case 'defaultDateTimeFormat':
        return 'PP p';
      case 'defaultTimeFormat':
        return 'p';
    }
  }, []);
